import { Editor } from '@tiptap/core';
import { createContext, useContext, useState } from 'react';

interface CurrentDocumentEditorContextType {
  editor: Editor | null;
  setEditor: (editor: Editor | null) => void;
}

const EditorContext = createContext<CurrentDocumentEditorContextType>({
  editor: null,
  setEditor: () => {},
});

export const CurrentDocumentEditorProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  return (
    <EditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </EditorContext.Provider>
  );
};

export const useCurrentDocumentEditor =
  (): CurrentDocumentEditorContextType => {
    const context = useContext(EditorContext);

    if (!context) {
      throw new Error('useEditor must be used within an EditorProvider');
    }

    return context;
  };
